import React from 'react'
import ReactDOM from 'react-dom'

import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'

const getDarkModeSettings = () => {
  let isDarkMode = false

  try {
    isDarkMode = window.localStorage.getItem('swroller-darkmode') === 'true'
  } catch(e) {}

  return isDarkMode
}

const isDarkMode = getDarkModeSettings()

ReactDOM.render(
  <React.StrictMode>
    <App isDarkMode={isDarkMode} />
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
